import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import { useNavigate } from "react-router-dom";
import "../../styles/App.css";
import { NO_GROUP_TEXT } from "../../components/GroupLabel.js";

const AddActPage = () => {
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState("");
  const [violationDate, setViolationDate] = useState("");
  const [reason, setReason] = useState("");
  const [file, setFile] = useState(null); 
  const navigate = useNavigate();
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch(`${API}/api/students`, {
          headers: { Authorization: getAuthHeader() },
        });
        const data = await response.json();
        setStudents(data);
        setFilteredStudents(data); 
      } catch (error) {
        console.error("Помилка завантаження студентів:", error);
      }
    };

    fetchStudents();
  }, []);

  useEffect(() => {
    const filtered = students.filter((student) =>
      student.pib.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredStudents(filtered);
  }, [searchTerm, students]);

  const handleSubmit = async (type) => {
    if (!selectedStudent || !violationDate || !reason) {
      alert("Будь ласка, заповніть усі обов’язкові поля!");
      return;
    }

    setSearchTerm(""); 

    const formData = new FormData();
    formData.append("student_id", selectedStudent);
    formData.append("date", violationDate);
    formData.append("reason", reason);
    formData.append("type", type); 
    if (file) {
      formData.append("file", file); 
    }

    try {
      const response = await fetch(`${API}/api/upload-record`, {
        method: "POST",
        body: formData,
        headers: { Authorization: getAuthHeader() },
      });

      if (!response.ok) {
        const error = await response.json();
        console.error("Server error:", error);
        alert(`Помилка: ${error.error || "Невідома помилка"}`);
        return;
      }

      const data = await response.json();
      alert(
        type === "act"
          ? "Акт успішно створено!"
          : "Попередження успішно виписано!"
      );
      navigate(-1);
    } catch (error) {
      console.error("Помилка відправки:", error);
      alert("Не вдалося завершити операцію. Спробуйте пізніше.");
    }
  };

  return (
    <div className="page-container">
      <h2 className="header-content-title">Створення акту для студента</h2>
      <form>
        <div className="form-container">
          <div className="input-block text-header">
            Студент:
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Введіть ПІБ студента"
              className="input-component"
            />
            <select
              value={selectedStudent}
              onChange={(e) => setSelectedStudent(e.target.value)}
              required
              className="input-component"
            >
              <option value="" disabled>
                <p className="text-header">Оберіть студента</p>
              </option>
              {filteredStudents.map((student) => (
                <option key={student.id} value={student.id}>
                  {student.pib} ({student.group || NO_GROUP_TEXT})
                </option>
              ))}
            </select>
          </div>

          <div className="input-block">
            <p className="text-header">Дата порушення:</p>
            <input
              type="date"
              value={violationDate}
              onChange={(e) => setViolationDate(e.target.value)}
              required
              className="input-component"
              style={{
                width: "100%",
              }}
            />
          </div>
        </div>

        <div className="">
          <p className="text-header">Причина порушення: </p>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Введіть причину порушення"
            required
            className="input-component"
            style={{
              width: "100%",
              minHeight: "50px",
            }}
          />
        </div>

        <div className="">
          <p className="text-header">Завантаження акту (необов’язково):</p>
          <input
            id="fileInput"
            type="file"
            onChange={(e) => setFile(e.target.files[0])} 
            className="input-component"
            style={{
              width: "100%",
            }}
          />
        </div>

        <div className="header-content">
          <button
            type="button"
            onClick={() => handleSubmit("act")}
            className="restore-button"
            style={{ width: "50%" }}
          >
            Створити акт
          </button>
          <button
            type="button"
            onClick={() => handleSubmit("warning")}
            className="remove-button"
            style={{ width: "50%" }}
          >
            Виписати попередження
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddActPage;
